import { Typography, TypographyTypeMap } from '@mui/material'
import { ElementType } from 'domelementtype'
import parse, { DOMNode } from 'html-react-parser'
import { renderMarkdownToHtml } from '@omnea-app/fe-rich-text/renderMarkdownToHtml'

type Props = {
  markdownString: string
  typographyProps?: TypographyTypeMap['props']
  linkifyEmails?: boolean
}

/**
 * @deprecated - use `MarkdownTextContent` from `@omnea-app/fe-rich-text` instead
 */
const RenderMarkdown = ({ markdownString, typographyProps, linkifyEmails }: Props): React.ReactElement => {
  const TransformFunc = (node: DOMNode) => {
    if (node.type === ElementType.Tag && node.name === 'a' && node.attribs) {
      const href = node.attribs.href

      if (!href || !/^https?:\/\//i.test(href)) {
        return
      }

      node.attribs.target = '_blank'
      node.attribs.rel = 'noreferrer noopener'
    }
  }

  const { sx: typographySx, ...restTypographyProps } = typographyProps ?? {}

  return (
    <Typography
      component="div"
      {...restTypographyProps}
      sx={[
        (theme) => ({
          display: 'block',
          '& a': {
            color: theme.palette.text.link,
            textDecoration: 'underline',
          },
          '& table': { borderCollapse: 'collapse', width: '100%', margin: theme.spacing(1, 0) },
          '& th, & td': {
            padding: theme.spacing(1.5, 2),
            verticalAlign: 'top',
            textAlign: 'left',
          },
          '& th': { ...theme.typography['body-medium'], background: theme.palette.bg.surface.subtle },
        }),
        ...(Array.isArray(typographySx) ? typographySx : [typographySx ?? {}]),
      ]}
    >
      {parse(renderMarkdownToHtml(markdownString, undefined, { linkifyEmails }), {
        replace: TransformFunc,
      })}
    </Typography>
  )
}

export { RenderMarkdown }
